import Api from '@services/api'

/**
 * Unlike the other `use*` composables here, this resolves no injection — a Pinia
 * store and a plain service both reach for the API client, and neither runs inside
 * a component setup. Call it where the request is made rather than at module scope,
 * so Story 4 can hand back a per-request client without touching call sites.
 */
export function useApi() {
    return Api
}
